import * as model from "@/model/prd/productionExecution/smelting/GasCabinetPara";
import { newEntityStoreHelper } from "@/store/common/entityModule";

function newFilter(paginationFilter={}){
    var filter = Object.assign({},paginationFilter,model.filter);
    return filter;
}

export default newEntityStoreHelper(() => new model.GasCabinetPara(), newFilter)
.withStates({
    idReport: 2,

    baseModuleUrl: process.env.VUE_APP_PRODUCTION_API_URL + "production-service/prd"
}) //TODO load at the application start    
.buildStore()